import { changePasswordSchema } from '#shared';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useForm } from '../lib/form';
import { Button, TextField } from './ui';

/** Shared by the first-login screen and the profile page. */
export function PasswordForm({ currentLabel, submitLabel, onDone }: { currentLabel: string; submitLabel: string; onDone?: () => void }) {
  const { reloadMe } = useAuth();
  const form = useForm(changePasswordSchema, { currentPassword: '', newPassword: '' });
  const next = form.values.newPassword;
  const checks = [
    { ok: next.length >= 8, label: 'At least 8 characters' },
    { ok: /[A-Za-z]/.test(next), label: 'Has a letter' },
    { ok: /\d/.test(next), label: 'Has a number' },
  ];

  return (
    <form
      noValidate
      className="space-y-5"
      onSubmit={(e) => {
        e.preventDefault();
        void form.submit(async (data) => {
          await api.post('/auth/change-password', data);
          toast.success('Your password has been changed.');
          form.setValues({ currentPassword: '', newPassword: '' });
          await reloadMe();
          onDone?.();
        });
      }}
    >
      <TextField label={currentLabel} type="password" autoComplete="current-password" required {...form.bind('currentPassword')} />
      <div>
        <TextField label="New password" type="password" autoComplete="new-password" required {...form.bind('newPassword')} />
        <ul className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-sm" aria-label="Password rules">
          {checks.map((c) => (
            <li key={c.label} className={c.ok ? 'text-emerald-700 dark:text-emerald-400' : 'text-slate-500'}>
              {c.ok ? '✓' : '○'} {c.label}
            </li>
          ))}
        </ul>
      </div>
      <Button type="submit" loading={form.submitting}>{submitLabel}</Button>
    </form>
  );
}
